/**
 * Resolve a root-absolute asset path (e.g. "/brand/cec-logo.png") to the
 * correct URL under the current deploy. In dev/preview this is a no-op
 * (PUBLIC_URL is empty so it stays "/brand/..."). In the FTP build we
 * pass PUBLIC_URL=/new at build time so the path becomes "/new/brand/...".
 */
export function assetUrl(path) {
  if (!path) return path;
  if (/^(https?:|data:|blob:)/i.test(path)) return path;
  const base = process.env.PUBLIC_URL || "";
  if (path.startsWith("/")) return `${base}${path}`;
  return `${base}/${path}`;
}
